<template>
  <section class="text-center mb-16">
    <h1 class="text-2xl font-bold mb-2">Sign in / Sign up</h1>
    <p class="font-light text-white text-opacity-50">
      {{ target === "desktop-sign-in" ? "Sample manager" : "Admin dashboard" }}
    </p>
    <transition name="fade" mode="out-in">
      <div v-if="!authenticated && authStateKnown" class="my-8">
        <FirebaseUI :redirectUrl="redirectUrl" />
      </div>
      <div v-else-if="authenticated && user" class="my-8">
        <img
          class="mx-auto rounded-full w-16 h-16 my-2"
          v-if="user.photoURL"
          :src="user.photoURL"
          :alt="user.displayName || user.email || 'profile photo'"
        />
        <h3 class="text-xl font-semibold">
          {{ user.displayName }}
        </h3>
        <h5 class="font-light text-sm text-white text-opacity-75">
          {{ user.email }}
        </h5>
        <div v-if="target === 'desktop-sign-in'" class="pt-4">
          <div v-if="desktopSignInLoading" class="animate-bounce">...</div>
          <div v-else>
            <button
              class="inline-flex items-center uppercase font-light px-6 py-2 border border-white rounded-md hover:bg-opacity-10 hover:bg-white transition-colors mb-6"
              @click="openDesktopApp"
            >
              Open App
            </button>
          </div>
        </div>
        <button
          class="font-semibold text-red-500 text-opacity-50 hover:text-opacity-100 transition-colors mt-8"
          @click="logout"
        >
          Logout
        </button>
      </div>
      <div v-else>
        <!-- Initialing -->
      </div>
    </transition>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import firebase from "firebase/app";
import FirebaseUI from "@/components/FirebaseUI.vue";

export default defineComponent({
  components: {
    FirebaseUI
  },
  data() {
    return {
      authStateKnown: false,
      authenticated: false,
      desktopSignInLoading: false,
      desktopSignInError: "",
      user: null as null | firebase.User
    };
  },
  computed: {
    target(): string | string[] | null {
      const { target = null } = this.$route.params;
      return target;
    },
    redirectUrl(): string {
      switch (this.target) {
        case "desktop-sign-in":
          return ("/auth/desktop-sign-in?ot-auth-code=" +
            this.$route.query["ot-auth-code"]) as string;
        default:
          return "/admin";
      }
    }
  },
  async mounted() {
    firebase.auth().onAuthStateChanged(user => {
      this.authStateKnown = true;
      if (user) {
        this.authenticated = true;
        this.user = user;
        switch (this.target) {
          case "desktop-sign-in":
            this.desktopSignIn(user);
            break;
          default:
            // Pass
            break;
        }
      } else {
        this.authenticated = false;
        this.user = null;
      }
    });
  },
  methods: {
    async desktopSignIn(user: firebase.User) {
      this.desktopSignInLoading = true;
      const otCode = this.$route.query["ot-auth-code"];
      const idToken = await user.getIdToken();
      const createAuthToken = firebase
        .functions()
        .httpsCallable("createAuthToken");
      try {
        await createAuthToken({ otCode, idToken });
        this.desktopSignInLoading = false;
      } catch (error) {
        this.desktopSignInError = error.message;
        console.error(error);
      }
    },
    openDesktopApp() {
      window.location.href = `${
        process.env.VUE_APP_ENDPOINTS === "production"
          ? "samply"
          : "samplystaging"
      }://`;
    },
    logout() {
      firebase.auth().signOut();
    }
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
